import { xget, xhttp } from "../Fetchv2.js";
import { PGSchema } from "../schemas/pg.schema.js";

/** Cuerpo POST: `name` y `absence_types` obligatorios en servidor; el resto tiene defaults. */
export type TimeOffPolicyCreateBody = Pick<PGSchema.hcm_time_off_policy, "name" | "absence_types"> &
	Partial<
		Omit<
			PGSchema.hcm_time_off_policy,
			"id" | "created_at" | "updated_at" | "pgid" | "name" | "absence_types" | "usersPages"
		>
	>;

export type TimeOffPolicyUpdateBody = Partial<
	Omit<PGSchema.hcm_time_off_policy, "id" | "created_at" | "updated_at" | "pgid" | "usersPages">
>;

/** Normaliza la respuesta del listado (array, un objeto o vacío). */
export function normalizeTimeOffPolicies(
	rsp: PGSchema.hcm_time_off_policy[] | PGSchema.hcm_time_off_policy | null | undefined
): PGSchema.hcm_time_off_policy[] {
	if (rsp == null) return [];
	if (Array.isArray(rsp)) return rsp;
	return [rsp];
}

export class TimeOffPolicies {
	/**
	 * Todas las políticas de la página (`pgid`).
	 * @GET /pages/:pgid/time-off-policies
	 */
	async list(pgid: PGSchema.pages["id"], token?: string) {
		return xget<PGSchema.hcm_time_off_policy[]>(`/pages/${pgid}/time-off-policies`, undefined, {
			headers: token ? { "app-token": token } : undefined
		});
	}

	/**
	 * Una política por id (debe pertenecer a `pgid`).
	 * @GET /pages/:pgid/time-off-policies/:itemId
	 */
	async getById(pgid: PGSchema.pages["id"], itemId: PGSchema.hcm_time_off_policy["id"], token?: string) {
		return xget<PGSchema.hcm_time_off_policy>(`/pages/${pgid}/time-off-policies/${itemId}`, undefined, {
			headers: token ? { "app-token": token } : undefined
		});
	}

	/** @POST /pages/:pgid/time-off-policies */
	async create(pgid: PGSchema.pages["id"], data: TimeOffPolicyCreateBody, token?: string) {
		return xhttp<PGSchema.hcm_time_off_policy>(`/pages/${pgid}/time-off-policies`, "POST", data, {
			headers: token ? { "app-token": token } : undefined
		});
	}

	/** @PUT /pages/:pgid/time-off-policies/:itemId */
	async update(
		pgid: PGSchema.pages["id"],
		itemId: PGSchema.hcm_time_off_policy["id"],
		data: TimeOffPolicyUpdateBody,
		token?: string
	) {
		return xhttp<PGSchema.hcm_time_off_policy>(`/pages/${pgid}/time-off-policies/${itemId}`, "PUT", data, {
			headers: token ? { "app-token": token } : undefined
		});
	}

	/** @DELETE /pages/:pgid/time-off-policies/:itemId */
	async delete(pgid: PGSchema.pages["id"], itemId: PGSchema.hcm_time_off_policy["id"], token?: string) {
		return xhttp<{ deleted: boolean }>(`/pages/${pgid}/time-off-policies/${itemId}`, "DELETE", {}, {
			headers: token ? { "app-token": token } : undefined
		});
	}
}
